import { afterNextRender, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly translateService = inject(TranslateService);

  constructor() {
    afterNextRender(() => {
      /**
       * Ngx-Translate 초기화
       */
      const language = localStorage.getItem('language');
      this.translateService.use(language || 'ko-KR');
    });
  }
}
